import React from 'react';
import { Location } from 'history';

export type UtmParameters = Readonly<{
  utm_medium: 'web' | 'email' | 'text' | 'calendar';
  utm_source: string;
  utm_campaign: string;
}>;

export const UtlQueryParams = {
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_campaign: 'utm_campaign',
} as const;

export interface NavigationOptions
  extends Readonly<{
    scrollToTop?: boolean;
    replace?: boolean;
  }> {}
export interface RoutesContextProps
  extends Readonly<{
    isAdminRoute: boolean;
    isGuestRoute: boolean;
    location: Location;
    utmQueryParameters?: UtmParameters;
    buildPath: (route: string) => string;
    goToAdmin: () => void;
    goToMe: () => void;
    setScrollToTop: () => void;
    goToAccountMeRoute: (route: string) => void;
    goToAdminRoute: (route: string) => void;
    goToExactRoute: (route: string, queryParams?: string) => void;
    buildRelativeUrl: (route: string, utmParameters: UtmParameters) => string;
    navigateWithUtm: (route: string) => void;
  }> {}

export const RoutesContext = React.createContext<RoutesContextProps | undefined>(undefined);
